import { DEFAULT_COLUMN_WIDTH } from '../../table/consts.js';
import { columnManager, } from '../columns/manager.js';
export class BaseDataSource {
    constructor() {
        this.columnConfigManager = columnManager;
    }
    cellChangeRenderValue(rowId, propertyId, value) {
        this.cellChangeValue(rowId, propertyId, value);
    }
    cellGetRenderValue(rowId, propertyId) {
        return this.cellGetValue(rowId, propertyId);
    }
    cellGetExtra(_rowId, _propertyId) {
        return undefined;
    }
    propertyGetReadonly(_propertyId) {
        return false;
    }
    propertyGetDefaultWidth(_propertyId) {
        return DEFAULT_COLUMN_WIDTH;
    }
    onCellUpdate(_rowId, _propertyId, _callback) {
        return {
            dispose: () => {
                //
            },
        };
    }
    captureSync() {
        //
    }
    get detailSlots() {
        return {};
    }
}
//# sourceMappingURL=base.js.map